
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Formulario from './components/formulario';
import Response from './components/formulario/Response';
import Confirmation from './components/formulario/Confirmation';

function App() {
  return (
    <BrowserRouter>
      <Routes>
          <Route path="response" element={<Response />} />
          <Route path="confirmation" element={<Confirmation />} />
          <Route path="/" element={<Formulario />}>
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
